import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const fetchMipsPatients = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    name,
    dob,
    sex,
    mobile_phone,
    start_age,
    end_age,
    mips,
    order_by
  } = filter;

  try {
    let searchName = name ? `&name=${name}` : "";
    let searchDOB = dob ? `&dob=${dob}` : "";
    let searchSex = sex ? `&gender=${sex}` : "";
    let searchNumber = mobile_phone ? `&mobile_phone=${mobile_phone}` : "";
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let startAge = start_age ? `&start_age=${start_age}` : "";
    let endAge = end_age ? `&end_age=${end_age}` : "";
    let searchMips = mips
      ? `&mips=${JSON.stringify(mips)}`
      : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    const response =  await axios.get(
      `${Config.apiServerUrl}/mips/list?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchName}${searchDOB}${searchSex}${searchNumber}${startAge}${endAge}${searchParam}${searchMips}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const importMips = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(`${Config.apiServerUrl}/mips/bulk-upload`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteMipsNote = async (id, account_id, location_id) => {
  try {
    const response = await axios.delete(
      `${Config.apiServerUrl}/mips/delete?account_id=${account_id}&location_id=${location_id}&id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteBulkMipsData = async (deleteData) => {
  try {
    const response = await axios.delete(`${Config.apiServerUrl}/mips/bulk-delete`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
      data: deleteData,
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};